import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="eyb-page min-h-[100dvh] w-full">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        offset={20}
        mobileOffset={16}
        toastOptions={{ style: { maxWidth: "360px", margin: "0 auto" } }}
      />
    </div>
  );
}

export default App;
